import store from '@/store';

export default class EndChatvisorEvent {
  constructor(message) {
    console.log('[EndChatvisorEvent]', message);
    const chatvisorUser = `${message.agentId}@${message.supervisorId}`;
    const connected = false;

    store.dispatch('chatVisor/setSupervisorConnectedOnChat', {
      connected,
      chatvisorUser,
    });
  }
}
